module.exports = __webpack_public_path__ + "img/back-triple-impact.2b4c6013.webp";